export default __webpack_public_path__ + "static/media/024-washer.56fb8ed5.svg";